import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const SvgLogoBadge = (props: SvgProps) => (
  <Svg
    width="600"
    height="600"
    viewBox="0 0 600 600"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="600" height="600" rx="150" fill="black" />
    <path
      d="M141.13 475H226.02C236.445 475 244.884 466.562 244.884 456.136V390.599C244.884 386.136 248.354 382.65 252.833 382.65C256.303 382.65 259.789 385.126 260.783 388.612C281.635 454.148 353.622 474.495 407.234 474.495H458.859C469.285 474.495 477.723 466.057 477.723 455.631V370.237C477.723 359.811 469.285 351.372 458.859 351.372H384.395C375.956 351.372 371.982 341.451 377.944 335.489L460.357 253.076C467.802 245.631 471.777 235.694 471.777 225.268V143.864C471.777 133.438 463.338 125 452.912 125H371.004C361.083 125 351.146 128.975 343.701 136.42L261.288 218.833C255.326 224.795 244.9 220.315 244.9 211.877V143.864C244.9 133.438 236.461 125 226.035 125H145.594C135.168 125 126.729 133.438 126.729 143.864V223.785C126.729 234.211 135.168 242.65 145.594 242.65H214.095C222.534 242.65 226.509 253.076 220.546 259.038L176.856 299.748C145.105 329.543 122.266 371.23 122.266 414.921V456.12C122.266 466.546 130.704 474.984 141.13 474.984V475ZM312.408 354.858C289.079 354.369 268.228 356.341 253.338 345.915C238.938 333.502 241.43 312.161 240.436 294.29C240.925 276.42 239.442 253.091 251.351 241.167C263.259 229.243 286.603 229.748 303.969 230.252C322.344 231.246 343.685 228.77 356.098 243.155C366.02 258.044 364.048 278.896 364.537 302.224C364.048 316.625 364.537 332.997 354.616 343.927L353.622 344.921C343.196 354.353 326.319 353.864 312.423 354.842L312.408 354.858Z"
      fill="#F5FAD9"
    />
  </Svg>
);
export default SvgLogoBadge;
